// The Master Sheet guide (28_MasterSheet.jsx · ModuleHelp, Max 01/11).
const en = {
  btnsT: 'Load, add and export',
  btnsB: 'The SAP and NetSuite buttons reload those ledgers into the sheet. Add a row lets you type one line by hand, Columns chooses what you see, and Export Excel downloads the sheet.',
  legendT: 'Whose column is it',
  legendB: 'Columns are coloured by who fills them: a person, a person or the system, or the system alone. An empty cell in a manual column is waiting for somebody.',
  toolbarT: 'Search and filter',
  toolbarB: 'Type a word and press Enter to search, or pick a source (SAP, NetSuite, manual). Clear sort & filters resets the sheet once any is on.',
  sheetT: 'The sheet',
  sheetB: 'One row per order line. Rows load as you scroll, the column headers sort and filter, and the pinned rows at the bottom give the totals.',
  rowT: 'Per-row actions',
  rowB: 'View opens the row read-only. Edit changes the fields you may change, and Split divides one line across destinations. Delete shows only on a row typed by hand.',
};
const ko = {
  btnsT: '불러오기, 추가, 내보내기',
  btnsB: 'SAP와 NetSuite 버튼은 해당 원장을 시트에 다시 불러옵니다. 행 추가는 직접 한 줄을 입력하고, 열은 표시할 열을 고르며, Excel 내보내기는 시트를 내려받습니다.',
  legendT: '누가 채우는 열인지',
  legendB: '열 색은 입력 주체를 나타냅니다. 사람, 사람 또는 시스템, 시스템 전용입니다. 수동 열의 빈 셀은 누군가의 입력을 기다리는 것입니다.',
  toolbarT: '검색과 필터',
  toolbarB: '단어를 입력하고 Enter로 검색하거나 소스(SAP, NetSuite, 수동)를 고르세요. 필터가 켜져 있으면 필터 초기화로 되돌립니다.',
  sheetT: '시트',
  sheetB: '주문 라인당 한 행입니다. 스크롤하면 행이 더 불러와지고, 열 머리글로 정렬·필터하며, 아래 고정 행이 합계입니다.',
  rowT: '행별 작업',
  rowB: '보기는 읽기 전용으로 행을 엽니다. 수정은 바꿀 수 있는 필드를, 분할은 한 라인을 여러 목적지로 나눕니다. 삭제는 직접 입력한 행에만 나옵니다.',
};
const vi = {
  btnsT: 'Tải, thêm và xuất',
  btnsB: 'Nút SAP và NetSuite tải lại các ledger đó vào sheet. Thêm dòng để nhập tay một dòng, Cột để chọn cột hiển thị, Xuất Excel để tải sheet về.',
  legendT: 'Cột này của ai',
  legendB: 'Màu cột cho biết ai điền: người, người hoặc hệ thống, hay chỉ hệ thống. Ô trống ở cột nhập tay là đang chờ ai đó điền.',
  toolbarT: 'Tìm và lọc',
  toolbarB: 'Gõ từ khóa rồi nhấn Enter để tìm, hoặc chọn nguồn (SAP, NetSuite, nhập tay). Khi đang có bộ lọc, nút xóa bộ lọc đưa sheet về ban đầu.',
  sheetT: 'Bảng sheet',
  sheetB: 'Mỗi dòng là một dòng đơn hàng. Cuộn xuống sẽ tải thêm dòng, tiêu đề cột dùng để sắp xếp và lọc, các dòng ghim ở cuối là tổng.',
  rowT: 'Thao tác trên từng dòng',
  rowB: 'Xem mở dòng ở chế độ chỉ đọc. Sửa đổi các trường được phép, Tách chia một dòng ra nhiều điểm đến. Xóa chỉ có ở dòng nhập tay.',
};
const zh = {
  btnsT: '加载、新增与导出',
  btnsB: 'SAP 和 NetSuite 按钮会把对应的 ledger 重新加载到表中。新增行用于手工录入一行，列用于选择显示的列，导出 Excel 下载整张表。',
  legendT: '这一列由谁填写',
  legendB: '列的颜色表示填写方：人工、人工或系统、仅系统。手工列里的空单元格表示在等人填写。',
  toolbarT: '搜索与筛选',
  toolbarB: '输入关键字后按 Enter 搜索，或选择来源（SAP、NetSuite、手工）。已有筛选时，可用清除筛选恢复。',
  sheetT: '数据表',
  sheetB: '每个订单行一行。向下滚动会继续加载，列标题可排序和筛选，底部固定的行是合计。',
  rowT: '每行的操作',
  rowB: '查看以只读方式打开该行。编辑可修改允许修改的字段，拆分把一行分到多个目的地。删除只出现在手工录入的行上。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "btnsT": "Charger, ajouter et exporter",
  "btnsB": "Les boutons SAP et NetSuite rechargent ces registres dans la feuille. Ajouter une ligne permet de saisir une ligne à la main, Colonnes choisit ce que vous voyez, et Exporter Excel télécharge la feuille.",
  "legendT": "À qui appartient la colonne",
  "legendB": "Les colonnes sont colorées selon qui les remplit : une personne, une personne ou le système, ou le système seul. Une cellule vide dans une colonne manuelle attend quelqu'un.",
  "toolbarT": "Rechercher et filtrer",
  "toolbarB": "Saisissez un mot et appuyez sur Entrée pour rechercher, ou choisissez une source (SAP, NetSuite, manuel). Effacer tris et filtres réinitialise la feuille dès que l'un d'eux est actif.",
  "sheetT": "La feuille",
  "sheetB": "Une ligne par ligne de commande. Les lignes se chargent au défilement, les en-têtes de colonnes trient et filtrent, et les lignes épinglées en bas donnent les totaux.",
  "rowT": "Actions par ligne",
  "rowB": "Voir ouvre la ligne en lecture seule. Modifier change les champs que vous pouvez modifier, et Fractionner répartit une ligne entre plusieurs destinations. Supprimer n'apparaît que sur une ligne saisie à la main."
};
const ja = {
  "btnsT": "読み込み、追加、エクスポート",
  "btnsB": "SAP と NetSuite のボタンで、それぞれの台帳をシートに再読み込みします。「行を追加」で1行を手入力でき、「列」で表示内容を選び、「Excel をエクスポート」でシートをダウンロードします。",
  "legendT": "列の入力担当",
  "legendB": "列は入力する人によって色分けされます。人、人またはシステム、システムのみの3種類です。手入力の列が空欄のセルは、誰かの入力を待っています。",
  "toolbarT": "検索と絞り込み",
  "toolbarB": "キーワードを入力して Enter で検索するか、ソース（SAP、NetSuite、手入力）を選択します。並べ替えやフィルターが有効な間は、「並べ替えとフィルターをクリア」でシートが元に戻ります。",
  "sheetT": "シート",
  "sheetB": "注文明細ごとに1行です。スクロールに合わせて行が読み込まれ、列見出しで並べ替えと絞り込みができ、下部に固定された行が合計を表示します。",
  "rowT": "行ごとの操作",
  "rowB": "「表示」でその行を読み取り専用で開きます。「編集」で変更可能な項目を変更でき、「分割」で1つの明細を複数の納入先に分けます。「削除」は手入力した行にのみ表示されます。"
};

const dictionary = { ns: 'tourMasterSheet', en, ko, vi, zh, fr, ja };
export default dictionary;
